/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpenseBatchApprovedRequest
 */
export interface ExpenseBatchApprovedRequest {
    /**
     * 
     * @type {string}
     * @memberof ExpenseBatchApprovedRequest
     */
    clientPurchaseOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseBatchApprovedRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the ExpenseBatchApprovedRequest interface.
 */
export function instanceOfExpenseBatchApprovedRequest(value: object): value is ExpenseBatchApprovedRequest {
    return true;
}

export function ExpenseBatchApprovedRequestFromJSON(json: any): ExpenseBatchApprovedRequest {
    return ExpenseBatchApprovedRequestFromJSONTyped(json, false);
}

export function ExpenseBatchApprovedRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseBatchApprovedRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientPurchaseOrder': json['clientPurchaseOrder'] == null ? undefined : json['clientPurchaseOrder'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ExpenseBatchApprovedRequestToJSON(value?: ExpenseBatchApprovedRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientPurchaseOrder': value['clientPurchaseOrder'],
        'comment': value['comment'],
    };
}

